// CalendlyEmbedded.js
import { useEffect } from "react";

const ProjectWorkflow = () => {
  const useExternalScript = (url) => {
    useEffect(() => {
      const script = document.createElement("script");
      script.src = url;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }, [url]);
  };
  useExternalScript("https://assets.calendly.com/assets/external/widget.js");
  return (
    <>
      <style>{`
        .sectionBody.calendlySectionBody {
        background-color: #ebebeb;
          padding: 4rem 4rem 6rem 4rem;
          position: relative;
        }
        .calendlySectionBody .workflowContainer {
          margin: 0 0 30px 0;
        }
        .calendlySectionBody .wf_desc_wrapper {
          align-items: center;
          width: 100%;
        }
      `}</style>
      <div className="sectionBody calendlySectionBody">
        <div className="workflowContainer">
          <div className="wf_desc_wrapper">
            <div className="wf_title">Schedule a Walk Through</div>
          </div>
        </div>
        {/* <!-- Calendly inline widget begin --> */}
        <div className="calendly-inline-widget" data-url="https://calendly.com/visinvo/30min?hide_event_type_details=1&hide_gdpr_banner=1&background_color=ffffff&text_color=444444&primary_color=0f618a" style={{minWidth:320,width:500,maxWidth:"90%",minHeight:500,height:"auto"}}></div>
        {/* <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script> */}
        {/* <!-- Calendly inline widget end --> */}
      </div>
    </>
  )
};

export default ProjectWorkflow;
